import React from "react";
import "../../css_files/Homepage/Pagination.css";

function Pagination({ count, setpagenumber, pagenumber }) {
  return (
    <section className="pagination">
      <h2>Total Pages: {count}</h2>

      <blockquote>
        {Array.from({ length: count }, (_, i) => i + 1).map((x) =>
          x + 5 <= pagenumber || x - 5 >= pagenumber ? (
            <></>
          ) : (
            <button
              onClick={() => setpagenumber(x)}
              style={{
                backgroundColor: x === pagenumber && "red",
                color: x === pagenumber && "white",
              }}
            >
              {x}
            </button>
          )
        )}
      </blockquote>
      <input
        type="number"
        placeholder="Jump To Page"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setpagenumber(e.target.value);
          }
        }}
      />
    </section>
  );
}

export default Pagination;
